"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSIAID = void 0;
const validateSIAID = sia_id => {
  return sia_id.length === 6;
};
exports.validateSIAID = validateSIAID;